var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDessert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    width: "",
    height: "",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m424.615 44.077c-3.804-2.242-8.402-2.693-12.57-1.235-42.78 14.972-85.428 29.823-119.598 41.708-10.771-11.827-25.271-20.188-41.615-23.249-4.248-24.731-19.88-46.091-42.901-57.602l-4.223-2.111c-7.406-3.704-16.418-.701-20.124 6.708-3.705 7.409-.702 16.42 6.708 20.124l4.223 2.111c12.925 6.463 22.11 17.906 25.75 31.376-31.689 7.253-55.778 34.622-58.065 67.908-48.871 16.984-100.747 35.035-152.155 53.028-6.017 2.105-10.044 7.784-10.044 14.157h-.001v160h.013c.001 6.205 3.864 12.01 10.054 14.165l402 140c1.604.56 3.271.835 4.933.835 1.793 0 3.578-.321 5.268-.955.406-.1.915-.213 1.514-.352 8.292-1.917 30.318-7.01 50.251-23.396 25.193-20.709 37.967-51.09 37.967-90.297v-200c0-4.142-.993-102.014-87.385-152.923zm-187.615 45.923c24.813 0 45 20.187 45 45s-20.187 45-45 45-45-20.187-45-45 20.187-45 45-45zm-70.654 70.133c10.357 29.029 38.112 49.867 70.654 49.867 41.355 0 75-33.645 75-75 0-8.43-1.419-16.53-3.995-24.099 31.313-10.893 69.014-24.023 107.177-37.374 66.038 43.279 66.818 122.654 66.818 123.473 0 69.574-50.127 111.266-67.09 123.376l-82.955-29.034c-4.587-1.605-9.67-.89-13.635 1.925-3.965 2.812-6.32 7.372-6.32 12.233v61.5c0 8.271-6.729 15-15 15s-15-6.729-15-15v-82.5c0-6.388-4.045-12.075-10.08-14.17l-211.323-73.377c35.859-12.516 71.499-24.915 105.749-36.82zm85.654 183.281-222-77.084v-48.244l222 77.084zm-222-45.327 222.807 77.364c3.967 20.786 22.268 36.549 44.193 36.549 11.17 0 21.395-4.1 29.27-10.862l75.73 26.505v48.25l-372-129.552zm372 97.771-60.66-21.23c.426-2.481.66-5.027.66-7.627v-40.357l60 21zm80 1.142c0 41.032-16.4 67.328-50 79.975v-131.916c11.016-7.779 32.194-24.785 50-51.129z",
    fill: "currentColor",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412,
    cy: 132,
    r: 15,
    fill: "currentColor",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 202,
    r: 15,
    fill: "currentColor",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 262,
    r: 15,
    fill: "currentColor",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352,
    cy: 192,
    r: 15,
    fill: "currentColor",
    "data-original": "currentColor",
    className: ""
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDessert);
export default __webpack_public_path__ + "static/media/dessert.93dd52879a0de58d6cab32802c974fea.svg";
export { ForwardRef as ReactComponent };